import { UNKNOWN, sortCleanTranslate, populatePlayerPositionMap } from './utils';
import { SportName } from '@shared/enums/SportName';

const GOALKEEPER = 'goalkeeper';
const ATTACKER = 'attacker';
const CENTER = 'center';
const DEFENDER = 'defender';
const LEFT_DEFENDER = 'left_defender';
const RIGHT_DEFENDER = 'right_defender';
const RIGHT_WINGER = 'right_winger';
const LEFT_WINGER = 'left_winger';

export class IceHockeyPlayerPositionHandler {
	#playerPositionsMap = {
		[GOALKEEPER]:     [],
		[ATTACKER]:       [],
		[CENTER]:         [],
		[LEFT_DEFENDER]:  [],
		[RIGHT_DEFENDER]: [],
		[RIGHT_WINGER]:   [],
		[LEFT_WINGER]:    [],
		[UNKNOWN]:        [],
	};

	constructor(players) {
		populatePlayerPositionMap(this.#playerPositionsMap, players);
	}

	getLineup() {
		const playerPositionMap = this.#playerPositionsMap;

		const newPlayerPositionMap = {
			[GOALKEEPER]: [
				...playerPositionMap[GOALKEEPER],
			],
			[ATTACKER]: [
				...playerPositionMap[ATTACKER],
				...playerPositionMap[CENTER],
				...playerPositionMap[LEFT_WINGER],
				...playerPositionMap[RIGHT_WINGER],
			],
			[DEFENDER]: [
				...playerPositionMap[LEFT_DEFENDER],
				...playerPositionMap[RIGHT_DEFENDER],
			],
			[UNKNOWN]: [
				...playerPositionMap[UNKNOWN],
			],
		};

		return sortCleanTranslate(newPlayerPositionMap, SportName.ICE_HOCKEY);
	}
}
